import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const updateTrainingEnrollment = createAsyncThunk(
  "AgentTrainingIssues/updateTrainingEnrollment",
  async (data, thunkAPI) => {
    let { schema, handleSuccess, handleError } = data;
    try {
      const resp = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/users/mentorship/enrollment/${data?.id}`,
        schema,
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "application/json",
          },
        }
      );
      if (handleSuccess && resp?.data) {
        handleSuccess();
      }
      return resp.data;
    } catch (error) {
      if (error.response) {
        if (handleError) {
          handleError(
            error.response.data.errorMessage || error.response.data.message
          );
        }
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        if (handleError) {
          handleError(error.message);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
